import { PromoBannersIdFiltersType } from '../containers/PromoBannersIdFilters/PromoLandingsFilters.types'

export const preparePromoBannerIdFiltersInput = (values?: PromoBannersIdFiltersType) => ({
  ...values,
})
